import Box from "@mui/material/Box";

const ContentBox = ({ children }) => {
  return (
    <Box
      sx={{
        padding: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {children}
    </Box>
  );
};

export default ContentBox;